module.exports = __webpack_public_path__ + "HP_Latex_630_Printer_series-Lifestyle.jpg?7da06df2e765491c494e9dfc21e576dd";